// External link redirect to new tan
      document.addEventListener('DOMContentLoaded', function () {
        const currentHost = window.location.hostname;

        document.querySelectorAll('a[href]').forEach((link) => {
          try {
            const url = new URL(link.href);

            if (url.hostname !== currentHost) {
              link.setAttribute('target', '_blank');
              link.setAttribute('rel', 'noopener noreferrer');
            }
          } catch (e) {
            // Ignore invalid URLs
          }
        });
      });
  
// QTY + atc
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__info-container').forEach((container) => {
    const qty = container.querySelector('.product-form__quantity');
    if (!qty) return;

    const atcWrapper = qty.nextElementSibling;

    if (!atcWrapper || atcWrapper.tagName !== 'DIV') return;

    if (qty.closest('.qty_add_cart')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'qty_add_cart';

    qty.before(wrapper);
    wrapper.appendChild(qty);
    wrapper.appendChild(atcWrapper);
  });
});


// Footer Menu
document.addEventListener('DOMContentLoaded', () => {
  const desktop = window.matchMedia('(min-width: 750px)');

  const toggleFooter = () => {
    document.querySelectorAll('.footer-block').forEach(block => {
      if (desktop.matches) {
        block.setAttribute('open', '');
      } else {
        block.removeAttribute('open');
      }
    });
  };

  toggleFooter();
  desktop.addEventListener('change', toggleFooter);
});

